import { useMemo } from 'react';
import Combobox from '@/components/ui/Combobox.jsx';

export default function SearchableSelect({
  value,
  onChange,
  options = [],
  placeholder = 'Seleccionar',
  searchPlaceholder = 'Buscar...',
  emptyMessage = 'Sin resultados',
  disabled = false,
}) {
  const normalizedOptions = useMemo(
    () => options
      .filter(Boolean)
      .map((option) => ({
        value: String(option.value ?? option.id ?? ''),
        label: option.label ?? option.nombre ?? option.descripcion ?? String(option.value ?? option.id ?? ''),
      })),
    [options],
  );

  return (
    <Combobox
      value={value}
      onChange={onChange}
      options={normalizedOptions}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      emptyMessage={emptyMessage}
      disabled={disabled}
      renderInPortal
      className="w-full"
    />
  );
}
